module.exports = __webpack_public_path__ + "img/stabdardTariffHead.cb3f3472.png";